/**
 * Vitaviva — Chat trigger
 *
 * Intercepts clicks on any <a href="#open-chat"> link and programmatically
 * opens the Shopify Inbox chat widget.
 *
 * Why this exists:
 * - Shopify Inbox has no public deep-link / URL. The chat is always rendered
 *   as an on-page widget. To make a regular "Chat med os" CTA button open
 *   the chat in place, we trigger the widget ourselves.
 *
 * How Inbox renders on the storefront (as of inbox-1270, May 2026):
 * - <script id="chat-button-container">           - loader script (NOT the bubble)
 * - <div   id="shopify-chat">                     - widget mount point
 * - <inbox-online-store-chat id="ShopifyChat">    - custom element, the bubble
 *     #shadow-root
 *       <link rel="stylesheet" ...>
 *       <button>Chat</button>                     - the actual click target
 *     /shadow-root
 *     is-open="false"|"true"                      - widget state attribute
 *
 * To open the chat we click the <button> inside the shadow root. The Inbox
 * widget's React app listens on that button and toggles is-open. Clicking
 * the host element directly does NOT trigger React's handler — it must be
 * the shadow-root button.
 *
 * Robustness:
 * - The Inbox loader is injected via app embed and the custom element +
 *   shadow root boot asynchronously. A user can click our CTA before the
 *   shadow button exists, so we retry briefly (~3s).
 * - If chat is already open (is-open="true"), we do nothing — clicking the
 *   shadow button when chat is open toggles the wrong control (mobile
 *   header back button etc.).
 * - If Inbox isn't installed/enabled (no #ShopifyChat in DOM), the click
 *   falls through silently — href="#open-chat" doesn't navigate anywhere
 *   visible to the user.
 */
(function () {
  'use strict';

  var CHAT_HREF = '#open-chat';
  var CHAT_ELEMENT_ID = 'ShopifyChat';
  var MAX_RETRIES = 20;        // ~3s total at 150ms interval
  var RETRY_INTERVAL_MS = 150;

  function openInboxChat() {
    var host = document.getElementById(CHAT_ELEMENT_ID);
    if (!host) return false;

    // Already open — nothing to do.
    if (host.getAttribute('is-open') === 'true') return true;

    if (!host.shadowRoot) return false;

    var button = host.shadowRoot.querySelector('button');
    if (!button) return false;

    try {
      button.click();
      return true;
    } catch (e) {
      return false;
    }
  }

  function openWithRetry() {
    if (openInboxChat()) return;

    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (openInboxChat() || attempts >= MAX_RETRIES) {
        clearInterval(timer);
      }
    }, RETRY_INTERVAL_MS);
  }

  document.addEventListener('click', function (event) {
    // Walk up from the click target to find an <a> with the chat marker.
    var node = event.target;
    while (node && node !== document.body) {
      if (
        node.tagName === 'A' &&
        (node.getAttribute('href') === CHAT_HREF ||
          (node.hash && node.hash === CHAT_HREF))
      ) {
        event.preventDefault();
        event.stopPropagation();
        openWithRetry();
        return;
      }
      node = node.parentNode;
    }
  });
})();
